import { ContactContext } from '@spa/components/organisms/contact/model/context/contact-context'

export class ContactOnMyPageContext implements ContactContext {
  static build(): ContactOnMyPageContext {
    return new ContactOnMyPageContext()
  }

  get path() {
    return {
      editContact: '/mypage/edit/contact',
      addContact: '/mypage/edit/new-contact',
    }
  }

  get title() {
    return 'お届け先の確認'
  }
}
